import { Component } from "react"
import PropTypes from "prop-types"
import { FormControl, TextField, DialogContent, DialogActions, Button } from "@mui/material"

export default class EditName extends Component {
  constructor(props, ...args) {
    super(props, ...args)
    this.state = {
      name: props.name,
    }
  }

  static propTypes = {
    name: PropTypes.string,
    close: PropTypes.func,
    save: PropTypes.func.isRequired,
  }

  setName = event => {
    this.setState({ name: event.target.value })
  }

  save = () => {
    const { save, close } = this.props
    const { name } = this.state
    save(name)
    close()
  }

  render() {
    const { name } = this.state
    const { close } = this.props

    return <>
      <DialogContent className="modules_filter-saver_components_edit-name">
        <FormControl variant="standard">
          <TextField
            variant="standard"
            className="name"
            placeholder="Saved Search Name"
            value={name}
            onChange={this.setName}
            autoFocus
            slotProps={{
              htmlInput: { maxLength: 80 },
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" disabled={!name} onClick={this.save}>
          Save
        </Button>
      </DialogActions>
    </>
  }
}
